import React from 'react';
import { MapPin, Ship, Anchor } from 'lucide-react';

const RouteFinderTabs = ({ active, setActive }) => {
    return (
        <div className="bg-white rounded shadow-sm mb-3">
            <div className="d-flex">
                <button
                    className={`btn d-flex align-items-center gap-2 py-2 px-4 border-0 rounded-0 ${active === 'route' ? 'text-primary fw-bold' : 'text-secondary'}`}
                    onClick={() => setActive('route')}
                >
                    <MapPin size={18} />
                    Route
                </button>

                <button
                    disabled={true}
                    className={`btn d-flex align-items-center gap-2 py-2 px-4 border-0 rounded-0 ${active === 'vessel' ? 'text-primary fw-bold' : 'text-secondary'}`}
                    onClick={() => setActive('vessel')}>
                    <Ship size={18} />
                    Vessel
                </button>

                <button
                    disabled={true}
                    className={`btn d-flex align-items-center gap-2 py-2 px-4 border-0 rounded-0 ${active === 'port' ? 'text-primary fw-bold' : 'text-secondary'}`}
                    onClick={() => setActive('port')}>
                    <Anchor size={18} />
                    Port
                </button>
            </div>
        </div>
    );
};

export default RouteFinderTabs;
